import { render } from "./needupload.vue?vue&type=template&id=f5e1c3c4&scoped=true"
import script from "./needupload.vue?vue&type=script&lang=js"
export * from "./needupload.vue?vue&type=script&lang=js"

import "./needupload.vue?vue&type=style&index=0&id=f5e1c3c4&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5e1c3c4"]])

export default __exports__